import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ddf5130"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "contentLeft",
  id: "contentLeft"
}
const _hoisted_2 = {
  class: "article",
  style: {"text-align":"left"}
}
const _hoisted_3 = { class: "time-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { onMounted, ref, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ArchiveResults } from "@/api/apitypes/response/ArticleResponse";
import { postArticlesArchive } from "@/api/functions/archive";
import {
  ArticleSearchRequest,
  initArticleSearchRequest,
} from "@/api/apitypes/request/ArticleSearchRequest";
import { parseTime } from "@/functions/utils/DateUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'ArchiveContent',
  setup(__props) {

const state = reactive({
  data: new Object() as ArchiveResults,
});

const color = () => {
  return "#" + Math.random().toString(16).substr(2, 6).toUpperCase();
};

const route = useRoute();

const router = useRouter();

const searchInput = ref(route.query.key);

const articleSearchRequest: ArticleSearchRequest = initArticleSearchRequest();

const searchRouter = () => {
  router.replace({
    path: "/search",
    query: { key: searchInput.value },
  });
};

const tagSearchHandle = (tag: string) => {
  articleSearchRequest.tag = tag;
};

const archiveSearchHandle = async () => {
  await postArticlesArchive(articleSearchRequest).then((res) => {
    state.data = res.data;
  });
};

onMounted(async () => {
  await archiveSearchHandle();
  var scrollDom = document.getElementById("contentLeft") as HTMLElement;
  window.scrollTo({
    top: scrollDom.getBoundingClientRect().top,
    behavior: "smooth",
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("menus.archive.name")), 1),
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("menus.archive.tag")), 1),
      _createVNode(_component_el_space, {
        size: 10,
        wrap: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.tagGroup, (tag) => {
            return (_openBlock(), _createBlock(_component_el_badge, {
              value: tag.count
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  round: "",
                  color: color(),
                  onClick: ($event: any) => (tagSearchHandle(tag.tag))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag.tag), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "onClick"])
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 256))
        ]),
        _: 1
      }),
      _createVNode(_component_el_divider),
      _createVNode(_component_el_timeline, { style: {"padding-left":"10px"} }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.articlesSort, (articleSort) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              timestamp: articleSort.year.toString(),
              placement: "top"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleSort.articles, (article) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_component_router_link, {
                      class: "",
                      to: {
                name: 'detail',
                params: { theme: article.theme },
              }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, {
                          shadow: "hover",
                          "body-class": "article-between"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              (article.deleteFlag)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    effect: "dark",
                                    round: "",
                                    type: "danger"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 已删除 ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (article.draftFlag)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 1,
                                    effect: "dark",
                                    round: "",
                                    type: "info"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 已隐藏 ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(article.title), 1)
                            ]),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(parseTime)(article.createTime, "{m}-{d}")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _hoisted_4
                  ]))
                }), 256))
              ]),
              _: 2
            }, 1032, ["timestamp"]))
          }), 256))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})